/**
 * 업데이트 연대기
 */

import { Fragment } from 'react';
import { setYMDDateFormat } from '@utils/index';
import { SERVICE_ALIAS } from '@constants/index';

const ContentListArticle = ({ item, l10n, option }) => {
  const { serviceAlias } = option || {};

  if (!item) {
    return <Fragment />;
  }

  const { link, thumbnail, title, summary, serverType, updateDate, categoryName } = item || {};
  return (
    <div className="search-item-content">
      <div className="search-item-thumbnail">
        <a href={link}>
          <img src={thumbnail} alt="" />
        </a>
      </div>
      <div className="search-item-article">
        <div className="search-item-title">
          <a href={link} dangerouslySetInnerHTML={{ __html: title }}></a>
        </div>
        <div className="search-item-summary">
          <a href={link} dangerouslySetInnerHTML={{ __html: summary }}></a>
        </div>
        <div className="search-item-info">
          {serviceAlias === SERVICE_ALIAS.LINEAGE2 ? <span>{categoryName}</span> : <Fragment />}
          <span>{setYMDDateFormat(updateDate)}</span>
        </div>
      </div>
    </div>
  );
};

export default ContentListArticle;
